import { IDieuChinhRequest } from "../../../model/request/hoa-don-dien-tu/IDieuChinhRequest";
import { IHoaDonDienTuPagingRequest } from "../../../model/request/hoa-don-dien-tu/IHoaDonDienTuPagingRequest";
import {
  IBienLaiThuViewModel,
  ITrangThaiXuatHoaDon,
} from "../../../model/respone/bien-lai/IBienLaiThu";
import { IPagingResult } from "../../../model/respone/IPagingResult";
import { IHoaDonDienTuActionTypes } from "../../action-types/hoa-don/IHoaDonDienTuAction";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IHoaDonDienTuReducer } from "../../reducer-model/hoa-don/IHoaDonDienTuReducer";

const iniState: IHoaDonDienTuReducer = {
  bienLais: {} as IPagingResult<IBienLaiThuViewModel[]>,
  request: {
    id_hes: [],
    hoc_ky: 0,
    nam_hoc: "",
    id_lops: [],
    id_nganhs: [],
    id_thu_chis: [],
    khoa_hocs: [],
    page_index: 0,
    page_size: 100,
    search_key: "",
    id_chuyen_nganhs: [],
    id_khoas: [],
    id_hinh_thuc_thanh_toans: [],
    nguoi_thu: "",
    id_co_sos: [],
    trang_thai_hoa_don: "all",
    trang_thai_xuat_hoa_don: "all",
    is_all_hk_namhoc: true,
    id_nhom_thu_chi: 0,
  } as IHoaDonDienTuPagingRequest,
  status: eReducerStatusBase.is_not_initialization,
  idSelections: [],
  isShowFilter: false,
  isShowDanhSachXuat: false,
  hoaDonDienTuChonXuats: [],
} as IHoaDonDienTuReducer;

export const hoaDonDienTuReducer = (
  state: IHoaDonDienTuReducer = iniState,
  action: IHoaDonDienTuActionTypes,
): IHoaDonDienTuReducer => {
  switch (action.type) {
    case "HOA_DON_DIEN_TU_LOAD_START":
      return {
        ...state,
        bienLais: {} as IPagingResult<IBienLaiThuViewModel[]>,
        request: action.payload,
        status: eReducerStatusBase.is_loading,
      };
    case "HOA_DON_DIEN_TU_LOAD_SUCCESS":
      return {
        ...state,
        bienLais: action.payload,
        status: eReducerStatusBase.is_completed,
      };
    case "HOA_DON_DIEN_TU_LOAD_ERRR":
      return {
        ...state,
        bienLais: {} as IPagingResult<IBienLaiThuViewModel[]>,
        status: eReducerStatusBase.is_completed,
      };
    case "HOA_DON_DIEN_TU_CHANGE_REQUEST":
      return {
        ...state,
        request: {
          ...state.request,
          ...action.payload,
        },
      };
    // case "HOA_DON_DIEN_TU_SHOW_DETAIL_MODAL":
    //   return {
    //     ...state,
    //     idShowViewDetail: action.payload,
    //   };
    // case "HOA_DON_DIEN_TU_HIDE_DETAIL_MODAL":
    //   return {
    //     ...state,
    //     idShowViewDetail: 0,
    //   };
    case "HOA_DON_DIEN_TU_SHOW_HIDE_FILTER":
      return {
        ...state,
        isShowFilter: action.payload,
      };
    case "HOA_DON_DIEN_TU_SELECTED_ID":
      return {
        ...state,
        idSelections: action.payload,
      };
    case "HOA_DON_DIEN_TU_PHAT_HANH_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "HOA_DON_DIEN_TU_PHAT_HANH_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        request: {
          ...state.request,
        },
        hoaDonDienTuView: undefined,
      };
    case "HOA_DON_DIEN_TU_PHAT_HANH_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
      };
    case "HOA_DON_DIEN_TU_PHAT_HANH_MULTIPLE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
        hoaDonDienTuChonXuats: state.hoaDonDienTuChonXuats.map((g) => {
          return {
            ...g,
            trangThaiXuatHoaDon: {
              message: "",
              status: eReducerStatusBase.is_saving,
            },
          };
        }),
      };
    case "HOA_DON_DIEN_TU_PHAT_HANH_MULTIPLE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        request: {
          ...state.request,
        },

        // hoaDonDienTuChonXuats: [],
        // isShowDieuChinhModal: false,
        // idSelections: [],
      };
    case "HOA_DON_DIEN_TU_PHAT_HANH_MULTIPLE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
        hoaDonDienTuChonXuats: state.hoaDonDienTuChonXuats.map((g) => {
          return {
            ...g,
            trangThaiXuatHoaDon: {
              status: eReducerStatusBase.is_saved,
              message: g.trangThaiXuatHoaDon.message,
            },
          };
        }),
      };
    case "HOA_DON_DIEN_TU_PHAT_HANH_MULTIPLE_CANCEL":
      return {
        ...state,
        hoaDonDienTuChonXuats: [],
        isShowDanhSachXuat: false,
        idSelections: [],
      };
    case "HOA_DON_DIEN_TU_PHAT_HANH_MULTIPLE_SHOWHIDE_MODAL":
      return {
        ...state,
        isShowDanhSachXuat: action.payload,
      };
    case "HOA_DON_DIEN_TU_SHOW_DIEU_CHINH_MODAL":
      return {
        ...state,
        isShowDieuChinhModal: true,
        dieuChinhEditing: {
          id_bien_lai: action.payload,
          ly_do_dieu_chinh: "",
        } as IDieuChinhRequest,
      };
    case "HOA_DON_DIEN_TU_HIDE_DIEU_CHINH_MODAL":
      return {
        ...state,
        isShowDieuChinhModal: false,
        dieuChinhEditing: undefined,
      };
    case "HOA_DON_DIEN_TU_DIEU_CHINH_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "HOA_DON_DIEN_TU_DIEU_CHINH_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowDieuChinhModal: false,
        dieuChinhEditing: undefined,
      };
    case "HOA_DON_DIEN_TU_DIEU_CHINH_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
      };
    case "HOA_DON_DIEN_TU_HUY_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "HOA_DON_DIEN_TU_HUY_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "HOA_DON_DIEN_TU_HUY_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
      };
    case "HOA_DON_DIEN_TU_SYNC_STATUS_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
        isShowsyncing: true,
        processId: action.payload.process_id,
      };
    case "HOA_DON_DIEN_TU_SYNC_STATUS_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "HOA_DON_DIEN_TU_SYNC_STATUS_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
      };
    case "HOA_DON_DIEN_TU_CLOSE_SYNCING_MODAL":
      return {
        ...state,
        isShowsyncing: false,
      };
    case "HOA_DON_DIEN_TU_VIEW_DETAIL_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "HOA_DON_DIEN_TU_VIEW_DETAIL_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
        hoaDonDienTuView: action.payload,
      };
    case "HOA_DON_DIEN_TU_VIEW_DETAIL_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
      };
    case "HOA_DON_DIEN_TU_EXPORT_HOA_DON_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "HOA_DON_DIEN_TU_VIEW_DETAIL_HIDE_MODAL":
      return {
        ...state,
        hoaDonDienTuView: undefined,
      };
    case "HOA_DON_DIEN_TU_PREVIEW_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
        hoaDonDienTuChonXuats: state.hoaDonDienTuChonXuats.map((g) => {
          if (g.id_bien_lai === action.payload.id_bien_lai) {
            return {
              ...g,
              trangThaiXuatHoaDon: {
                message: "",
                status: eReducerStatusBase.is_saving,
              },
            };
          }
          return g;
        }),
      };
    case "HOA_DON_DIEN_TU_PREVIEW_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
        hoaDonDienTuView: action.payload,
        hoaDonDienTuChonXuats: state.hoaDonDienTuChonXuats.map((g) => {
          if (g.id_bien_lai === action.payload.id_bien_lai) {
            return {
              ...g,
              trangThaiXuatHoaDon: {
                message: "",
                status: eReducerStatusBase.is_completed,
              },
            };
          }
          return g;
        }),
      };
    case "HOA_DON_DIEN_TU_PREVIEW_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
        hoaDonDienTuChonXuats: state.hoaDonDienTuChonXuats.map((g) => {
          return {
            ...g,
            trangThaiXuatHoaDon: {
              message: "",
              status: eReducerStatusBase.is_completed,
            },
          };
        }),
      };
    case "HOA_DON_DIEN_TU_PHAT_HANH_MULTIPLE_SELECTION":
      const chooses = Array.from(
        new Map(
          [...state.hoaDonDienTuChonXuats, ...action.payload.data]
            .filter((g) => !action.payload.idRemove.includes(g.id_bien_lai))
            .map((item) => [item.id_bien_lai, item]),
        ).values(),
      );
      return {
        ...state,
        hoaDonDienTuChonXuats: chooses,
        idSelections: chooses.map((g) => g.id_bien_lai),
        isShowDanhSachXuat:
          state.isShowDanhSachXuat ||
          (state.hoaDonDienTuChonXuats.length === 0 && chooses.length > 0),
      };
    case "HOA_DON_DIEN_TU_PHAT_HANH_MULTIPLE_CHANGE_LOAIHOADON":
      return {
        ...state,
        hoaDonDienTuChonXuats: state.hoaDonDienTuChonXuats.map((g) => {
          if (g.id_bien_lai === action.payload.id_bien_lai) {
            return {
              ...g,
              idConfigInvoice: action.payload.data,
            };
          }
          return g;
        }),
      };
    case "HOA_DON_DIEN_TU_CHANGE_TRANGTHAI_XUATHOADON":
      return {
        ...state,
        hoaDonDienTuChonXuats: state.hoaDonDienTuChonXuats.map((g) => {
          if (g.id_bien_lai === action.payload.id_bien_lai) {
            return {
              ...g,
              trang_thai_xuat_hd: action.payload.data.is_success,
              trangThaiXuatHoaDon: {
                message: action.payload.data.message,
                status: eReducerStatusBase.is_saved,
              } as ITrangThaiXuatHoaDon,
            };
          }
          return g;
        }),
        bienLais: {
          ...state.bienLais,
          data: state.bienLais.data.map((g) => {
            if (g.id_bien_lai === action.payload.id_bien_lai) {
              return {
                ...g,
                trang_thai_xuat_hd: action.payload.data.is_success,
              };
            }
            return g;
          }),
        },
      };

    case "HOA_DON_DIEN_TU_PHAT_HANH_NHAP_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "HOA_DON_DIEN_TU_PHAT_HANH_NHAP_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        request: {
          ...state.request,
        },
        hoaDonDienTuView: undefined,
      };
    case "HOA_DON_DIEN_TU_PHAT_HANH_NHAP_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
      };

    case "HOA_DON_DIEN_TU_EXPORT_HOA_DON_SUCCESS":
    case "HOA_DON_DIEN_TU_EXPORT_HOA_DON_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
      };
    case "HOA_DON_DIEN_TU_EXPORT_EXCEL_CHON_XUAT_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "HOA_DON_DIEN_TU_EXPORT_EXCEL_CHON_XUAT_SUCCESS":
    case "HOA_DON_DIEN_TU_EXPORT_EXCEL_CHON_XUAT_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "HOA_DON_DIEN_TU_EXPORT_EXCEL_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "HOA_DON_DIEN_TU_EXPORT_EXCEL_SUCCESS":
    case "HOA_DON_DIEN_TU_EXPORT_EXCEL_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
      };
    default:
      return state;
  }
};
